/* eslint-disable */
import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import closeSvg from 'src/assets/close.svg';
import { CommonDropdown, ICommonDropdownOption, RegularButton } from 'pg-ui-library';
import {
  CloseIcon,
  MainContainer,
  Text,
  ChoiceContainer,
  TextChoice,
  HeaderContainer,
  FooterContainer,
} from './styles';
import { useMutation, useQuery } from '@tanstack/react-query';
import PaymentsService from 'src/services/payments.service';
import { AlertAdapter } from 'pg-ui-library';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from 'src/hooks/useLocalStorage';

export const DistributionModal: React.FC<{
  isOpen: boolean;
  onClose?: Function;
}> = ({ isOpen, onClose }) => {
  const [userRole] = useLocalStorage('userRole', null);
  if (userRole === 'external_manager') return null;
  const [modalIsOpen, setIsOpen] = useState<boolean>(isOpen);
  const [mailMethod, setMailMethod] = useState<string>('ESS'); // Default to 'ESS'
  const { t } = useTranslation();

  const { isLoading, data: distribution } = useQuery({
    queryKey: ['payments/distribution'],
    queryFn: () => PaymentsService.getDistributionMethod(),
    enabled: true,
  });

  const dropdownOptions: ICommonDropdownOption[] = [
    {
      key: 'ESS',
      label: 'I consent to review W-2s electronically in this portal',
      value: 'ESS',
    },
    {
      key: 'user',
      label: 'I require my W2 to be mailed to me',
      value: 'user',
    },
  ];

  useEffect(() => {
    if (distribution?.data?.method) {
      const method = distribution.data.method;
      if (method === 'user') {
        setMailMethod('user');
      } else {
        setMailMethod('ESS');
      }
    } else {
      setMailMethod('ESS');
    }
  }, [distribution]);

  const mutation = useMutation((method: any) => PaymentsService.postDistributionMethod(method || 'ESS'), {
    onSuccess: () => {
      AlertAdapter(t('distributionModal.onSave'), 'success');
      close();
    },
    onError: () => {
      AlertAdapter(t('distributionModal.onError'), 'error');
    },
  });

  const close = () => {
    if (onClose) {
      onClose();
    }
    setIsOpen(false);
  };

  useEffect(() => {
    setIsOpen(isOpen);
  }, [isOpen]);

  return (
    <ReactModal
      isOpen={modalIsOpen}
      ariaHideApp={false}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          margin: 'auto',
          width: '900px',
          maxWidth: '900px',
          height: '350px',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <MainContainer>
        <HeaderContainer>
          <Text>{t('distributionModal.title')}</Text>
        </HeaderContainer>
        <ChoiceContainer>
          <TextChoice>{t('distributionModal.choice')}</TextChoice>
          <CommonDropdown
            label=""
            id="distribution_method"
            name="distribution_method"
            value={mailMethod}
            options={dropdownOptions}
            wrapperStyle={{ width: '100%' }}
            setValue={(value: any) => {
              setMailMethod(value);
            }}
            selectStyle={{
              minWidth: '55%',
              marginLeft: '2%',
              border: '0.3px rgb(100,100,100) solid',
            }}
          />
        </ChoiceContainer>
        <FooterContainer>
          <RegularButton
            onClick={() => {
              mutation.mutate(mailMethod);
            }}
          >
            {t('global.form.save')}
          </RegularButton>
        </FooterContainer>
      </MainContainer>
    </ReactModal>
  );
};
